import React, {useEffect, useState} from "react";
import classNames from "classnames";
import {useSnackbar} from "notistack";
import {get, getErrorMessage, SWITCH} from "../../service/Client";
import IntervalBar from "components/IntervalBar/IntervalBar";
import {useQuery} from "react-query";
import {useSelector} from "react-redux";
import NTMTable from "../../components/Table/NTMTable";
import moment from "moment";

export default function SwitchData() {

	let [data, setData] = useState([])
	let [device, setDevice] = useState();
	let [interval, setInterval] = useState("daily");
	let [startDate, setStartDate] = useState();
	let [endDate, setEndDate] = useState();
	let project = useSelector(store => store.session.project)
	const {enqueueSnackbar} = useSnackbar();
	const { data: devices = [] } = useQuery(["switch", { project: project?.id }], () =>
		get(`${SWITCH}/project/${project?.id}`),
		{ enabled: !!project });

	useEffect(getData, [interval, device, startDate, endDate]);

	function getData() {
		let promise
		if (interval === "daily") {
			promise = get(`${SWITCH}/${device}/today`);
		} else if (interval === "weekly") {
			promise = get(`${SWITCH}/${device}/week`);
		} else if (interval === "monthly") {
			promise = get(`${SWITCH}/${device}/month`);
		} else if (startDate !== null && endDate !== null) {
			let start = startDate.format("DD-MM-YYYY")
			let end = endDate.format("DD-MM-YYYY")
			promise = get(`${SWITCH}/${device}/custom`, { params: { start, end } });
		} else return;
		promise.then(setData).catch(e => enqueueSnackbar(getErrorMessage(e), {variant: "error"}))
	}

	if(devices.length === 0) return <div/>
	if(!device) {
		setDevice(devices[0].device)
	}

	function readMessage(message) {
		if(message === "aa") return "Aperto"
		if(message === "bb") return "Chiuso"
		let battery = parseInt(message.charAt(1)) / 9 * 100
		return `Batteria ${battery.toFixed()}%`
	}

	return (
		<div className={classNames("animated", "fadeIn")}>
			<IntervalBar
				devices={devices}
				device={device}
				setDevice={setDevice}
				interval={interval}
				setInterval={setInterval}
				startDate={startDate}
				setStartDate={setStartDate}
				endDate={endDate}
				setEndDate={setEndDate}
			/>

			<div style={{ minHeight: 400, margin: "1rem auto" }}>
				<NTMTable
					header={[
						{
							Header: "Data ricezione",
							accessor: 'received_at',
							Cell: props => <div>{`${moment(props.original.received_at).format("DD/MM/YYYY HH:mm")}`}</div>
						},
						{
							Header: "Messaggio",
							accessor: 'received_at',
							Cell: props => <div>{readMessage(props.original.data)}</div>
						}
					]}
					body={data}
					defaultPageSize={20}
				/>
			</div>
		</div>
	);
}
